import HostedPaymentIframeModal from '../HostedPaymentIframeModal';

/** @typedef {import('../../types').ResponseHandler} ResponseHandler */
/** @typedef {import('../../types').LoadModalResponse} LoadModalResponse */


/**
 * @type {ResponseHandler}
 * @param {LoadModalResponse} response
 */
const handle = (response, recaptcha) => new Promise(async () => {
  recaptcha.reset();

  const modalResult = await HostedPaymentIframeModal.open({
    iframeSrc: response.location,
    iframeOrigin: response.locationOrigin,
  });

  if (modalResult.wasCancelled) {
    window.location.reload();
  } else {
    window.location.href = response.responseUrl;
  }
});


export default {
  handle,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/ModalResponseHandler.js